import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ContractService } from '../services/contract.service';

@Pipe({
  name: 'erc20'
})
export class Erc20Pipe implements PipeTransform {

  constructor(
    private contractSrv: ContractService,
  ) { }

  async transform(address: string, field: string, sendAccount = false, sendContract = false): Promise<any> {
    let params: any = null;

    if (!address) { return }
    if (sendAccount) {
      const [account] = this.contractSrv.accounts;
      params = [account];
    }

    if (sendContract) {
      params = [environment.contractAddress];
    }

    if (address === "0x0000000000000000000000000000000000000000") {

      switch (field) {
        case "name":
          return "BNB";
        case "symbol":
          return "BNB";
      }
      return

    }

    return await this.contractSrv.calculateAndCallCustomABI({
      contractAddress: address,
      method: field,
      callType: 'call',
      params,
      optionals: null,
      urlABI: this.contractSrv.erc20ABI
    });
  }

}
